/**
 * LoginContent Component
 * Content displayed alongside login form — BE Study Automation System branding
 */

import React from 'react';
import { FileText, ClipboardCheck, Users, Wand2 } from 'lucide-react';

export function LoginContent() {
  const features = [
    {
      icon: FileText,
      title: 'Document Authoring',
      description: 'Create bioequivalence study reports from structured templates with guided workflows',
    },
    {
      icon: Wand2,
      title: 'AI-Assisted Drafting',
      description: 'Generate section content with confidence scoring and inline editing',
    },
    {
      icon: ClipboardCheck,
      title: 'Review & Approval',
      description: 'Streamlined review cycles with inline comments, version history, and audit trails',
    },
    {
      icon: Users,
      title: 'Role-Based Collaboration',
      description: 'Authors, reviewers, and admins working together with granular permissions',
    },
  ];

  return (
    <div className="max-w-lg text-center lg:text-left" data-testid="login-content">
      {/* Brand */}
      <div className="mb-8">
        <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-primary mb-4">
          <FileText className="h-7 w-7 text-primary-foreground" />
        </div>
        <h1 className="text-3xl font-bold text-foreground mb-2">
          BE Study Automation
        </h1>
        <p className="text-lg text-muted-foreground">
          Accelerate bioequivalence study report creation, review, and approval
        </p>
      </div>

      {/* Features */}
      <div className="space-y-4">
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <div key={index} className="flex items-start gap-4 text-left">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10">
                <Icon className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h3 className="font-semibold text-foreground">{feature.title}</h3>
                <p className="text-sm text-muted-foreground">{feature.description}</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Quote */}
      {/* <div className="mt-8 p-4 rounded-lg bg-background/50 border border-border">
        <p className="text-sm text-muted-foreground italic">
          "Reduced our BE study report turnaround from weeks to days. The template-driven workflow and reviewer collaboration tools are exceptional."
        </p>
        <p className="text-sm font-medium text-foreground mt-2">
          — Clinical Operations Lead, BioPharma Inc.
        </p>
      </div> */}
    </div>
  );
}

export default LoginContent;
